import { AlarmClock, CheckCircle2 } from "lucide-react";
import { fmtWIB, timeLeft } from "@/lib/datetime";
import { BOOKINGS } from "@/constants/testIds";

export const DeadlineCell = ({ booking, kind, field, done }) => {
  const reminder = booking.reminders.find((r) => r.kind === kind);
  if (booking[done]) {
    return (
      <div className="text-xs">
        <p className="text-slate-400 line-through tabular-nums">{fmtWIB(booking[field])}</p>
        <p className="mt-0.5 inline-flex items-center gap-1 font-medium text-emerald-600"><CheckCircle2 className="h-3.5 w-3.5" />{kind === "payment" ? "Lunas" : "Lengkap"}</p>
      </div>
    );
  }
  const tone = reminder ? (reminder.overdue ? "text-red-600" : "text-amber-600") : "text-slate-500";
  return (
    <div className="text-xs" data-testid={`${BOOKINGS.deadline}-${kind}`}>
      <p className="tabular-nums text-slate-800">{fmtWIB(booking[field])}</p>
      <p className={`mt-0.5 inline-flex items-center gap-1 font-medium ${tone}`}>
        {reminder && <AlarmClock className="h-3.5 w-3.5" />}{timeLeft(booking[field])}
      </p>
    </div>
  );
};
